<template>
  <section>
    <CerrarPlanilla />
    <AbrirCerrarPlanillaDetalle />
    <VerSeguimientoPlanilla />
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>assignment</v-icon>
          Procesar planillas
        </v-flex>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="py-0">
        <!-- Cuerpo del formulario -->
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-container class="p-0" grid-list-md style="min-width: 100%">
            <v-layout wrap row align-center justify-space-between>
              <v-flex md6 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  @input="actualizarDatosBotones()"
                  v-model.number="form.gestion"
                  type="number"
                  :rules="$validate(['required'])"
                  required
                  label="Seleccionar gestión (Solo para procesar planilla)"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex md6 xs12>
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="meses"
                  item-value="id"
                  item-text="valor"
                  v-model="form.mes"
                  @input="actualizarDatosBotones()"
                  :rules="$validate(['required'])"
                  required
                  label="Seleccionar mes (Solo para procesar planilla)"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 class="py-0">
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="unidades_especificas"
                  item-value="id_unidad"
                  item-text="nombre_unidad"
                  v-model="form.id_unidad_especifica"
                  @input="validarBotonProcesarPLanillaPorUnidad()"
                  label="Dependencia (Para procesar planilla)"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md4 class="py-0 pr-0">
                <v-btn
                  color="#0076A8"
                  @click="procesarPlanillaMEFP()"
                  :loading="loading"
                  title="Procesar planilla ASP-B"
                  dark
                  block
                >
                  <v-icon>schedule</v-icon>PROCESAR PLANILLA ASP-B
                </v-btn>
              </v-flex>
              <v-flex xs12 md4 class="text-xs-center p-0">
                <v-btn
                  color="rgb(252, 76, 2,0.9)"
                  @click="cerrarProcesoPlanilla()"
                  :loading="loading"
                  title="Cerrar proceso de planilla mensual"
                  dark
                  block
                >
                  <v-icon>lock</v-icon>CERRAR PROCESO DE PLANILLA MENSUAL
                </v-btn>
              </v-flex>

              <v-flex xs12 md4 class="py-0 pl-0">
                <v-btn
                  color="#0076A8"
                  @click="procesarPlanillaPorUnidad()"
                  :loading="loading_unidad"
                  title="Procesar planilla por dependencia"
                  dark
                  block
                >
                  <v-icon>schedule</v-icon>PROCESAR PLANILLA POR DEPENDENCIA
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 class="py-0">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.paterno"
                  label="Paterno"
                  outline
                  clearable
                  success
                  @input="filtraFuncionarios()"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-0">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.materno"
                  label="Materno"
                  outline
                  clearable
                  success
                  @input="filtraFuncionarios()"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-0">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.nombres"
                  label="Nombres"
                  outline
                  clearable
                  success
                  @input="filtraFuncionarios()"
                />
              </v-flex>

              <v-flex xs12 sm6 md4 class="py-0">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.ci"
                  label="Cédula de identidad"
                  outline
                  clearable
                  success
                  @input="filtraFuncionarios()"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-0">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.item"
                  label="Item"
                  outline
                  clearable
                  success
                  @input="filtraFuncionarios()"
                />
              </v-flex>
            </v-layout>
            <v-btn
              :disabled="!bandera_boton_buscar"
              color="rgba(31,14,180,0.7)"
              @click="filtraFuncionarios()"
              type="submit"
              dark
            >
              <v-icon>search</v-icon>
              Buscar
            </v-btn>
            <v-btn color="#90237b" @click="limpiarCampos()" type="submit" dark>
              <v-icon>redo</v-icon>
              Limpiar
            </v-btn>
          </v-container>
        </v-form>
        <v-data-table
          :headers="headers"
          :items="lista_filtrada_funcionarios"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :loading="loading"
          item-key="index"
          rows-per-page-text="Filas por pagina"
          :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 20, 50, { value: -1, text: 'Todos' }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                id="cabecera_tabla"
                class="header-comprmido"
                @click="changeSort(header.value)"
              >
                <v-icon v-if="header.value" small color="white"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-center py-0 px-1">
              <v-avatar
                :color="props.item.foto ? '#FFF' : 'light-blue darken-4'"
              >
                <img
                  v-if="props.item.foto"
                  :src="url_backend + props.item.foto"
                  :alt="props.item.nombres[0]"
                  style="border: 1px solid #7BAFD4 !important;"
                  @error="handleImageError(props.item)"
                />
                <span v-else class="white--text headline">{{
                  props.item.nombres[0] || "-"
                }}</span>
              </v-avatar>
            </td>
            <td class="text-xs-center py-0 px-1">
              {{ props.item.nro_item }}
            </td>
            <td class="text-xs-center py-0 px-1">
              {{ props.item.nombres }}
            </td>
            <td class="text-xs-center py-0 px-1">
              {{ props.item.ap_paterno }}
            </td>
            <td class="text-xs-center py-0 px-1">
              {{ props.item.ap_materno }}
            </td>
            <td class="text-xs-center py-0 px-1">
              {{ props.item.nro_doc }}
            </td>

            <td class="text-xs-center py-0 px-1">
              {{ props.item.dependencia }}
            </td>
            <td class="text-xs-center py-0 px-1">
              <v-chip
                dark
                small
                :color="props.item.cerrado ? '#DF4661' : '#6CC24A'"
              >
                <v-icon>{{ props.item.cerrado ? "lock" : "lock_open" }} </v-icon
                >{{ props.item.cerrado ? "CERRADO" : "ABIERTO" }}</v-chip
              ><br />
              {{ props.item.mes }}-{{ props.item.gestion }}
            </td>
            <td class="text-xs-center py-0 px-1">
              <v-btn
                v-if="props.item.mes && props.item.gestion"
                color="#CE0037"
                dark
                @click.prevent="abreCierraPlanillaDetalle(props.item)"
                icon
                :title="
                  props.item.cerrado
                    ? 'Abrir planilla detalle'
                    : 'Cerrar planilla detalle'
                "
              >
                <v-icon>{{ props.item.cerrado ? "lock_open" : "lock" }}</v-icon>
              </v-btn>
              <v-btn
                v-if="props.item.mes && props.item.gestion"
                color="blue"
                dark
                icon
                outline
                @click.prevent="verSeguimiento(props.item)"
                title="Ver seguimiento"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
              <v-btn
                v-if="!props.item.cerrado"
                color="#F58736"
                dark
                @click.prevent="procesarPlanillaPorFuncionario(props.item)"
                icon
                outline
                title="Procesar planilla"
                :loading="props.item.loading == true"
              >
                <v-icon>schedule</v-icon>
              </v-btn>
              <v-btn
                color="#0076A8"
                dark
                icon
                outline
                title="Ver detalle refrigerio"
                :to="
                  `/detalle-refrigerio/${props.item.id_persona}/${form.mes}/${form.gestion}`
                "
              >
                <v-icon>shopping_cart</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate";
import CerrarPlanilla from "./dialogs/CerrarPlanilla";
import AbrirCerrarPlanillaDetalle from "./dialogs/AbrirCerrarPlanillaDetalle.vue";
import VerSeguimientoPlanilla from "./dialogs/VerSeguimientoPlanilla.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  components: {
    CerrarPlanilla,
    AbrirCerrarPlanillaDetalle,
    VerSeguimientoPlanilla
  },
  // Variables iniciales del componente
  mixins: [validate],
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      form: {},
      valid: false,
      bandera_boton_buscar: true,
      bandera_boton_procesar: false,
      loading_unidad: false,
      bandera_boton_procesar_por_unidad: false,
      loading: false,
      meses: [
        { id: 1, valor: "ENERO" },
        { id: 2, valor: "FEBRERO" },
        { id: 3, valor: "MARZO" },
        { id: 4, valor: "ABRIL" },
        { id: 5, valor: "MAYO" },
        { id: 6, valor: "JUNIO" },
        { id: 7, valor: "JULIO" },
        { id: 8, valor: "AGOSTO" },
        { id: 9, valor: "SEPTIEMBRE" },
        { id: 10, valor: "OCTUBRE" },
        { id: 11, valor: "NOVIEMBRE" },
        { id: 12, valor: "DICIEMBRE" }
      ],
      headers: [
        {
          text: "",
          value: "",
          align: "center"
        },
        {
          text: "Item",
          value: "nro_item",
          align: "center"
        },
        {
          text: "Nombre",
          value: "nombres",
          align: "center"
        },
        {
          text: "Apellido paterno",
          value: "ap_paterno",
          align: "center"
        },
        {
          text: "Apellido materno",
          value: "ap_materno",
          align: "center"
        },
        {
          text: "Cédula de identidad",
          value: "nro_doc",
          align: "center"
        },
        {
          text: "Dependencia",
          value: "dependencia",
          align: "center"
        },
        {
          text: "Estado",
          value: "cerrado",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false }
      ],
      unidades_especificas: [],
      lista_funcionarios: [],
      lista_filtrada_funcionarios: [],
      user: this.$storage.get("user"),
      url_backend: process.env.API_URL.split("api/")[0]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("closeDialogCerrarPlanilla", async () => {
      await this.obtenerListaFuncionarios();
    });
    this.$bus.$on("closeDialogAbrirCerrarPlanillaDetalle", async () => {
      await this.obtenerListaFuncionarios();
    });
    this.form.gestion = new Date().getFullYear();
    this.form.mes = new Date().getMonth() + 1;
    this.bandera_boton_procesar = true;
    await this.cargarListaUnidadesEspecificas();
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    this.bandera_boton_buscar = true;
    await this.obtenerListaFuncionarios();
  },
  computed: {},
  // Métodos y funciones del componente
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para verificar si ocurrio un error al cargar la imagen
    handleImageError(item) {
      item.foto = "";
    },
    // Metodo para actualizar listado y botones de generacion de planillas
    actualizarDatosBotones() {
      this.validarBotonProcesarPLanilla();
      this.validarBotonProcesarPLanillaPorUnidad();
      this.obtenerListaFuncionarios();
    },
    validarBotonProcesarPLanilla() {
      if (this.form.gestion && this.form.mes) {
        this.bandera_boton_procesar = true;
      } else {
        this.bandera_boton_procesar = false;
      }
    },
    validarBotonProcesarPLanillaPorUnidad() {
      if (
        this.form.gestion &&
        this.form.mes &&
        this.form.id_unidad_especifica
      ) {
        this.bandera_boton_procesar_por_unidad = true;
      } else {
        this.bandera_boton_procesar_por_unidad = false;
      }
    },
    async procesarPlanillaMEFP() {
      try {
        let sw_abierto = await this.validaCierrePlanilla(
          this.form.mes,
          this.form.gestion
        );
        if (sw_abierto) {
          this.loading_unidad = true;
          if (this.form.gestion && this.form.mes) {
            let res = await this.$service.graphql({
              query: `
								mutation edit($procesa_planilla: ProcesaPlanillaMefp!){
									procesaPlanillaMefp(procesa_planilla: $procesa_planilla){
										mensaje
									}
								}  
							`,
              variables: {
                procesa_planilla: {
                  gestion: this.form.gestion,
                  mes: this.form.mes,
                  id_usuario: this.user.id
                }
              }
            });
            this.$message.info(res.procesaPlanillaMefp.mensaje);
          } else {
            this.$message.info("Seleccione gestión y mes");
          }
          this.loading_unidad = false;
        } else {
          this.$message.info(
            "La planilla del mes seleccionado se encuentra cerrada"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async procesarPlanillaPorFuncionario(dato) {
      try {
        dato.loading = true;
        if (this.form.gestion && this.form.mes && dato.id_persona) {
          let res = await this.$service.graphql({
            query: ` query{
            runQuery(consulta:"SELECT * FROM planilla.fn_crear_planilla_por_persona(${parseInt(
              this.form.gestion
            )},${parseInt(this.form.mes)},${parseInt(dato.id_persona)})"){
               respuesta
              }
            }
            `
          });
          if (res.runQuery.respuesta) {
            res = res.runQuery.respuesta[0].fn_crear_planilla_por_persona.split(
              "|"
            );
            if (res[0] == "1") {
              this.$message.success(
                "Se proceso correctamente la planilla del funcionario"
              );
            } else {
              this.$message.warning(res[1]);
            }
          }
        } else {
          this.$message.info("Seleccione gestión y mes");
        }
      } catch (error) {
        console.log(error);
      }
      dato.loading = false;
    },
    // Metodo para abrir dialog de cierre de planill
    async cerrarProcesoPlanilla() {
      let sw_abierto = await this.validaCierrePlanilla(
        this.form.mes,
        this.form.gestion
      );
      if (sw_abierto) {
        this.$bus.$emit("openDialogCerrarPlanilla", this.form);
      } else {
        this.$message.info(
          "La planilla del mes seleccionado se encuentra cerrada"
        );
      }
    },
    // Metodo para verificar si se cerro la planilla del mes
    async validaCierrePlanilla(mes, gestion) {
      try {
        var sw_abierto = true;
        let rpta = await this.$service.graphql({
          query: `
          query{
            cierrePlanillaMess(gestion:${gestion},mes:${mes}){
              rows{
                mes
                cerrado
                descripcion
              }
            }
          }
        `
        });
        let cierre = rpta.cierrePlanillaMess.rows;
        if (cierre[0] && cierre[0].cerrado) {
          sw_abierto = false;
        }
        return sw_abierto;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para cerrar o abrir el registro de planilla de un determinado funcionario
    async abreCierraPlanillaDetalle(item) {
      this.$bus.$emit("openDialogAbrirCerrarPlanillaDetalle", item);
    },
    // Metodo para abrir el dialog ver seguimiento
    verSeguimiento(item) {
      this.$bus.$emit("openDialogVerSeguimientoPlanilla", item);
    },
    async procesarPlanillaPorUnidad() {
      try {
        let sw_abierto = await this.validaCierrePlanilla(
          this.form.mes,
          this.form.gestion
        );
        if (sw_abierto) {
          this.loading_unidad = true;
          if (
            this.form.gestion &&
            this.form.mes &&
            this.form.id_unidad_especifica
          ) {
            let res = await this.$service.graphql({
              query: `
								mutation edit($procesa_planilla: ProcesaPlanillaUnidad!){
									procesaPlanillaUnidad(procesa_planilla: $procesa_planilla){
										mensaje
									}
								}  
							`,
              variables: {
                procesa_planilla: {
                  id_unidad: this.form.id_unidad_especifica,
                  gestion: this.form.gestion,
                  mes: this.form.mes,
                  id_usuario: this.user.id
                }
              }
            });
            this.$message.info(res.procesaPlanillaUnidad.mensaje);
          } else {
            this.$message.info("Seleccione gestión, mes y dependencia");
          }
          this.loading_unidad = false;
        } else {
          this.$message.info(
            "La planilla del mes seleccionado se encuentra cerrada"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo que filtra la lista de funcionarios
    filtraFuncionarios() {
      if (!this.form.materno) {
        this.form.materno = "";
      }
      if (!this.form.paterno) {
        this.form.paterno = "";
      }
      if (!this.form.nombres) {
        this.form.nombres = "";
      }
      if (!this.form.ci) {
        this.form.ci = "";
      }
      if (!this.form.item) {
        this.form.item = "";
      }
      this.lista_filtrada_funcionarios = this.lista_funcionarios.filter(
        persona =>
          (persona.ap_paterno ? persona.ap_paterno : "")
            .toUpperCase()
            .indexOf(this.form.paterno.toUpperCase()) != -1 &&
          (persona.ap_materno ? persona.ap_materno : "")
            .toUpperCase()
            .indexOf(this.form.materno.toUpperCase()) != -1 &&
          (persona.nombres ? persona.nombres : "")
            .toUpperCase()
            .indexOf(this.form.nombres.toUpperCase()) != -1 &&
          (persona.nro_item ? persona.nro_item : "")
            .toUpperCase()
            .indexOf(this.form.item.toUpperCase()) != -1 &&
          (persona.nro_doc ? persona.nro_doc : "")
            .toUpperCase()
            .indexOf(this.form.ci.toUpperCase()) != -1
      );
    },
    async obtenerListaFuncionarios() {
      this.lista_filtrada_funcionarios = [];
      if (!this.form.gestion) {
        this.$message.info("Seleccione gestion");
        return;
      }
      if (!this.form.mes) {
        this.$message.info("Seleccione mes");
        return;
      }
      try {
        this.bandera_boton_buscar = true;
        this.lista_funcionarios = [];
        this.loading = true;
        var query = `select * from planilla.fn_lista_funcionarios_planilla(${this.form.gestion},${this.form.mes}) as (id_persona integer,ap_paterno varchar,ap_materno varchar,nombres varchar,nro_doc varchar,nro_complemento varchar, nro_item varchar,cerrado boolean , dependencia varchar,gestion integer, mes integer,id_planilla_asistencia integer,foto varchar,id_tipo_justificacion integer,fecha_incorporacion date,fecha_retiro date, id_unidad integer)`;
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"${query}"){
                respuesta
              }
            }
          `
        });

        if (res.runQuery.respuesta.length != 0) {
          let lista_tmp = res.runQuery.respuesta;
          // Asignamos un loading por cada fila
          lista_tmp.forEach(element => {
            element.loading = false;
          });
          this.lista_funcionarios = lista_tmp;
          this.filtraFuncionarios();
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.obtenerListaFuncionarios();
      } catch (error) {
        console.log(error);
      }
    },
    async cargarListaUnidadesEspecificas() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              vUnidadesGeneraless{
                rows{
                  id_unidad
                  nombre_unidad
                  nivel
                }
              }
            }
          `
        });
        this.unidades_especificas = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    save() {
      try {
      } catch (error) {}
    }
  }
};
</script>

<style lang="scss">
.header-comprmido {
  background: rgb(180, 218, 233);
  white-space: pre-line !important;
  padding: 0em 0.5em 0em 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/Planillas.vue